import React, { Component } from 'react';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import SettingsForm from './SettingsForm';
import ui from '../../common/services/ui';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const renderForm = (data, t, isReadonly, onSubmit) => {
	const initialValues = data && data.initialValues;
	return <SettingsForm data={data} t={t} isReadonly={isReadonly} onSubmit={onSubmit} initialValues={initialValues} />;
}

const renderFooter = (t, onHide, isReadonly, onSubmit) => {
	const closeBtn = <Button key='close' onClick={onHide}>{t('Common_Close')}</Button>;
	const saveBtn = <RemoteSubmitButton key='save' style='success' disabled={isReadonly} formName='generateChildLessonsForm' label={t('Common_Save')} icon={faCheck} />;
	return [closeBtn, saveBtn];
}

const configureDialog = (t, onRenderForm, onHide, isReadonly) => {
	const footer = renderFooter(t, onHide, isReadonly);
	return {
		header: t('LessonAttendance_AddLesson'),
		body: onRenderForm(),
		onHide,
		footer
	};
}

class EditDialog extends Component {

	constructor(props) {
		super(props);
		this.handleParentSelect = this.handleParentSelect.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);
		this.handleHide = this.handleHide.bind(this);
		this.state = { parentId: '', childId: '' };
	}

	handleParentSelect(event, value) {
		this.handleFieldChange(value, 'parentId', 'onParentSelected', {}, { parentId: value, childId: '' });
	}

	handleChildSelect(event, value) {
		const { parentId } = this.state;
		this.handleFieldChange(value, 'childId', 'onChildSelected', { parentId });
	}

	handleFieldChange(newValue, fieldName, eventName, additionalData, newState) {
		const fieldValue = this.state[fieldName];
		if (fieldValue == newValue) {
			return
		}

		const event = this.props[eventName];
		if (event && newValue != '') {
			event(newValue, additionalData);
		}

		if (newState) {
			this.updateState(newState);
		} else {
			this.updateState({ [fieldName]: newValue });
		}
		// TODO: Clear redux form fields, dispatching change action
	}

	updateState(newState) {
		const oldState = this.state;
		this.setState({ ...oldState, ...newState });
	}

	handleHide() {
		const { onHide } = this.props;
		if (onHide) {
			onHide();
		}
		this.updateState({ parentId: '', childId: '' });
	}

	prepareData() {
		const { data: { parents, children, paymentHistories, weeklyProgramItem, lessonDate }, t } = this.props;
		const { parentId, childId } = this.state;

		return {
			parents,
			children: Object.keys(children).map(key => children[key]).filter(c => c.parentId == parentId),
			paymentHistories: this.preparePaymentHistory(parentId, childId, paymentHistories, t),
			onParentChange: this.handleParentSelect,
			onChildChange: this.handleChildSelect,
			disableChildInput: parentId == '',
			disablePaymentInput: parentId == '' || childId == '',
			initialValues: {
				grade: weeklyProgramItem && weeklyProgramItem.grade,
				lessonDate
			}
		};
	}

	preparePaymentHistory(parentId, childId, paymentHistories, t) {
		const paymentForTxt = t('LessonAttendance_PaymentFor');
		const paymentNumberTxt = t('LessonAttendance_PaymentNumber');
		const dateTxt = t('LessonAttendance_PaymentDate');

		return Object.keys(paymentHistories).map(key => {
			const ph = paymentHistories[key];
			const displayName = `${paymentForTxt} ${ph.term ? ph.term.name : ''} (${paymentNumberTxt} ${ph.id} ${dateTxt} ${ui.customDateFormat(ph.paymentDate, 'L')})`;
			return { ...ph, displayName };
		}).filter(ph => ph.parent && ph.parent.id == parentId && ph.child && ph.child.id == childId)
	}

	render() {
		const { t, show, isReadonly, onSubmit } = this.props;
		const preparedData = this.prepareData();
		const onRenderForm = () => renderForm(preparedData, t, isReadonly, onSubmit);
		const dialogConfig = configureDialog(t, onRenderForm, this.handleHide, isReadonly);
		
		return (
			<Dialog config={dialogConfig} show={show} t={t} />
		);
	};
}

export default EditDialog;